import { ConnectionsComponent } from '~/modules/org-settings/components/connections/connections.component';
import { uiRouterComponent } from '@mode/workspace-settings/feature-members-angularjs';
import { OrgSettingsComponent } from '~/modules/org-settings/org-settings.component';
import { OrgSettingsService } from '@mode/workspace-settings/shell-angularjs';

export const OrgSettingsRoutesConfig = [
  '$stateProvider',
  '$urlMatcherFactoryProvider',
  ($stateProvider, $urlMatcherFactoryProvider) => {
    $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider.state({
      abstract: true,
      name: 'org-settings',
      url: `/organizations/:orgUsername`,
      ...uiRouterComponent(OrgSettingsComponent),
      resolve: {
        currentUser: ['OrgSettingsService', (oss: OrgSettingsService) => oss.currentUser()],
        accountContext: ['OrgSettingsService', (oss: OrgSettingsService) => oss.currentOrganization()],
      },
    });

    $stateProvider.state({
      name: 'org-settings.connections',
      url: `/data_sources`,
      ...uiRouterComponent(ConnectionsComponent),
    });
  },
];
